import toast from 'react-hot-toast';
import NormalizedError from '../servicos/erros/NormalizedError';

async function smartToast(
    promise,
    {
        loadingMessage = 'Carregando...',
        delayToShowLoading = 800,
        apenasLoading = false
    } = {},
) {

    let loadingToastId = null;
    let hasShownLoading = false;

    // Timer: só mostra o toast de loading se demorar mais que delay
    const timer = setTimeout(() => {
        hasShownLoading = true;
        loadingToastId = toast.loading(loadingMessage);
    }, delayToShowLoading);

    try {

        const result = await promise;
        clearTimeout(timer);

        if (apenasLoading) {
            toast.dismiss(loadingToastId);
        } else {
            toast.success(result.data.message, { id: loadingToastId });
        }

        return result;

    } catch (err) {

        clearTimeout(timer);
        toast.dismiss(loadingToastId);

        console.log('erro no smart toast');
        console.log(err);

        if (!err.message) {
            throw new NormalizedError(
                "Erro inesperado. Tente novamente.",
                err
            );
        }
        else {
            throw err;
        }

    }
}

export default smartToast;